import { render, staticRenderFns } from "./DropdownCheckbox.vue?vue&type=template&id=da1478b0&"
import script from "./DropdownCheckbox.vue?vue&type=script&lang=ts&"
export * from "./DropdownCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownCheckbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
